"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiomBaseCircuit = void 0;
const tslib_1 = require("tslib");
const scaffold_1 = require("../scaffold");
const web_1 = require("@axiom-crypto/halo2-lib-js/wasm/web");
class AxiomBaseCircuit extends scaffold_1.AxiomBaseCircuitScaffold {
    constructor(inputs) {
        super(inputs);
        this.setContext({
            getKzgParams: web_1.getKzgParams,
        });
    }
    async setup(numThreads) {
        this.halo2wasm = await (0, web_1.getHalo2Wasm)(numThreads);
        this.halo2wasm.config(this.config);
    }
    newCircuitFromConfig(config) {
        super.newCircuitFromConfig(config);
        if (this.halo2Lib)
            this.halo2Lib.free();
        this.halo2Lib = (0, web_1.getHalo2LibWasm)(this.halo2wasm);
    }
}
exports.AxiomBaseCircuit = AxiomBaseCircuit;
tslib_1.__exportStar(require("../index"), exports);
//# sourceMappingURL=index.js.map